/* eslint-disable react/prop-types */
import { routes } from '@constants';
import {
  AboutUsPage,
  ActivitiesPage,
  ArticlePage,
  CardsDefinitionsPage,
  CertificateSettings,
  CertificationPage,
  CoursesPage,
  DeleteProfilePage,
  LearningMapPage,
  MainPage,
  ModulePage,
  NotFoundPage,
  OfflineContentPage,
  OnboardingPage,
  PrivacyPolicyPage,
  ProfilePage,
  ScenarioPage,
  SettingsPage,
  SoldierLevelPage,
  TermsOfServicePage,
  TestPage,
} from '@screens';
import { RootPageTemplate, ScreenWrapper } from '@templates';
import React from 'react';
import { createBrowserRouter } from 'react-router-dom';

import { CourseBreadcrumb, ModuleBreadcrumb } from './AppRouter.breadcrumbs';

const routeObject = [
  {
    children: [
      {
        element: (
          <ScreenWrapper>
            <MainPage />
          </ScreenWrapper>
        ),
        handle: {
          crumbs: [
            {
              path: routes.mainPage,
              title: 'Breadcrumbs.Home',
            },
          ],
        },
        path: routes.mainPage,
      },
      {
        element: (
          <ScreenWrapper>
            <DeleteProfilePage />
          </ScreenWrapper>
        ),
        handle: {
          crumbs: [
            {
              path: routes.mainPage,
              title: 'Breadcrumbs.Home',
            },
            {
              path: routes.deleteProfile,
              title: 'Breadcrumbs.Settings',
            },
          ],
        },
        path: routes.deleteProfile,
      },
      {
        element: (
          <ScreenWrapper>
            <OfflineContentPage />
          </ScreenWrapper>
        ),
        handle: {
          crumbs: [
            {
              path: routes.mainPage,
              title: 'Breadcrumbs.Home',
            },
            {
              path: routes.offlineContent,
              title: 'Breadcrumbs.OfflineContent',
            },
          ],
        },
        path: routes.offlineContent,
      },
      {
        element: (
          <ScreenWrapper>
            <SettingsPage />
          </ScreenWrapper>
        ),
        handle: {
          crumbs: [
            {
              path: routes.mainPage,
              title: 'Breadcrumbs.Home',
            },
            {
              path: routes.settings,
              title: 'Breadcrumbs.Settings',
            },
          ],
        },
        path: routes.settings,
      },
      {
        element: (
          <ScreenWrapper>
            <CertificateSettings />
          </ScreenWrapper>
        ),
        path: routes.certificateSettings,
      },
      {
        element: (
          <ScreenWrapper>
            <ProfilePage />
          </ScreenWrapper>
        ),
        handle: {
          crumbs: [
            {
              path: routes.mainPage,
              title: 'Breadcrumbs.Home',
            },
            {
              path: routes.profile,
              title: 'Breadcrumbs.Profile',
            },
          ],
        },
        path: routes.profile,
      },
      {
        element: (
          <ScreenWrapper>
            <CoursesPage />
          </ScreenWrapper>
        ),
        handle: {
          crumbs: [
            {
              path: routes.mainPage,
              title: 'Breadcrumbs.Home',
            },
            {
              path: routes.courses,
              title: 'Breadcrumbs.Courses',
            },
          ],
        },
        path: routes.courses,
      },
      {
        element: (
          <ScreenWrapper>
            <OnboardingPage />
          </ScreenWrapper>
        ),
        handle: {
          crumbs: [
            {
              path: routes.mainPage,
              title: 'Breadcrumbs.Home',
            },
            {
              path: routes.courses,
              title: 'Breadcrumbs.Courses',
            },
            {
              path: routes.onboarding,
              title: 'Breadcrumbs.Onboarding',
            },
          ],
        },
        path: routes.onboarding,
      },
      {
        element: (
          <ScreenWrapper>
            <CertificationPage />
          </ScreenWrapper>
        ),
        handle: {
          crumbs: [
            {
              path: routes.mainPage,
              title: 'Breadcrumbs.Home',
            },
            {
              path: routes.courses,
              title: 'Breadcrumbs.Courses',
            },
            {
              param: 'courseId',
              path: routes.course,
              title: CourseBreadcrumb,
            },
            {
              path: routes.certification,
              title: 'Breadcrumbs.Certification',
            },
          ],
        },
        path: routes.certification,
      },
      {
        element: (
          <ScreenWrapper>
            <SoldierLevelPage />
          </ScreenWrapper>
        ),
        handle: {
          crumbs: [
            {
              path: routes.mainPage,
              title: 'Breadcrumbs.Home',
            },
            {
              path: routes.courses,
              title: 'Breadcrumbs.Courses',
            },
            {
              param: 'courseId',
              path: routes.course,
              title: CourseBreadcrumb,
            },
          ],
        },
        path: routes.course,
      },
      {
        element: (
          <ScreenWrapper>
            <ModulePage />
          </ScreenWrapper>
        ),
        handle: {
          crumbs: [
            {
              path: routes.mainPage,
              title: 'Breadcrumbs.Home',
            },
            {
              path: routes.courses,
              title: 'Breadcrumbs.Courses',
            },
            {
              param: 'courseId',
              path: routes.course,
              title: CourseBreadcrumb,
            },
            {
              param: 'moduleId',
              path: routes.module,
              title: ModuleBreadcrumb,
            },
          ],
        },
        path: routes.module,
      },
      {
        element: (
          <ScreenWrapper>
            <LearningMapPage />
          </ScreenWrapper>
        ),
        handle: {
          crumbs: [
            {
              path: routes.mainPage,
              title: 'Breadcrumbs.Home',
            },
            {
              path: routes.learningMap,
              title: 'Breadcrumbs.LearningMap',
            },
          ],
        },
        path: routes.learningMap,
      },
      {
        element: (
          <ScreenWrapper>
            <AboutUsPage />
          </ScreenWrapper>
        ),
        handle: {
          crumbs: [
            {
              path: routes.mainPage,
              title: 'Breadcrumbs.Home',
            },
            {
              path: routes.about,
              title: 'Breadcrumbs.AboutUs',
            },
          ],
        },
        path: routes.about,
      },
      {
        element: (
          <ScreenWrapper>
            <ActivitiesPage />
          </ScreenWrapper>
        ),
        handle: {
          crumbs: [
            {
              path: routes.mainPage,
              title: 'Breadcrumbs.Home',
            },
            {
              path: routes.activities,
              title: 'Breadcrumbs.Activities',
            },
          ],
        },
        path: routes.activities,
      },
      {
        element: (
          <ScreenWrapper>
            <ArticlePage />
          </ScreenWrapper>
        ),
        handle: {
          crumbs: [
            {
              path: routes.mainPage,
              title: 'Breadcrumbs.Home',
            },
            {
              path: routes.activities,
              title: 'Breadcrumbs.Activities',
            },
            {
              path: `${routes.activities}/${routes.article}`,
              title: 'Breadcrumbs.Articles',
            },
          ],
        },
        path: `${routes.activities}/${routes.article}`,
      },
      {
        element: (
          <ScreenWrapper>
            <CardsDefinitionsPage />
          </ScreenWrapper>
        ),
        handle: {
          crumbs: [
            {
              path: routes.mainPage,
              title: 'Breadcrumbs.Home',
            },
            {
              path: routes.activities,
              title: 'Breadcrumbs.Activities',
            },
            {
              path: `${routes.activities}/${routes.cards}`,
              title: 'Breadcrumbs.Cards',
            },
          ],
        },
        path: `${routes.activities}/${routes.cards}`,
      },
      {
        element: (
          <ScreenWrapper>
            <TestPage />
          </ScreenWrapper>
        ),
        handle: {
          crumbs: [
            {
              path: routes.mainPage,
              title: 'Breadcrumbs.Home',
            },
            {
              path: routes.activities,
              title: 'Breadcrumbs.Activities',
            },
            {
              path: `${routes.activities}/${routes.test}`,
              title: 'Breadcrumbs.Tests',
            },
          ],
        },
        path: `${routes.activities}/${routes.test}`,
      },
      {
        element: (
          <ScreenWrapper>
            <ScenarioPage />
          </ScreenWrapper>
        ),
        handle: {
          crumbs: [
            {
              path: routes.mainPage,
              title: 'Breadcrumbs.Home',
            },
            {
              path: routes.activities,
              title: 'Breadcrumbs.Activities',
            },
            {
              path: `${routes.activities}/${routes.scenario}`,
              title: 'Breadcrumbs.Scenarios',
            },
          ],
        },
        path: `${routes.activities}/${routes.scenario}`,
      },
    ],
    element: <RootPageTemplate />,
    errorElement: <NotFoundPage />,
    path: routes.mainPage,
  },
  {
    element: (
      <ScreenWrapper>
        <TermsOfServicePage />
      </ScreenWrapper>
    ),
    path: routes.termsOfService,
  },
  {
    element: (
      <ScreenWrapper>
        <PrivacyPolicyPage />
      </ScreenWrapper>
    ),
    path: routes.privacyPolicy,
  },
];

const router = createBrowserRouter(routeObject);

export { routeObject, router };
